import React from 'react';
import styles from './NxRow.scss';
import clsx from 'clsx';
import NxGap from '../NxGap';

export enum NxRowPosition {
  START = 'START',
  CENTER = 'CENTER',
  END = 'END',
}


const notReachable = (): never => {
  throw new Error('Unknown value of nx row position');
};

const calculateFlexPosition = (position: NxRowPosition): 'flex-start' | 'center' | 'flex-end' => {
  switch(position) {
    case NxRowPosition.START:
      return 'flex-start';
    case NxRowPosition.CENTER:
      return 'center';
    case NxRowPosition.END:
      return 'flex-end';
    default:
      return notReachable();
  }
};

const NxRow = ({children, position = NxRowPosition.START, gap = NxGap.M}: { children: React.ReactNode, position?: NxRowPosition, gap? : NxGap }): React.ReactElement => {
  const nonEmptyChildren = React.Children.toArray(children);

  const classes = clsx(styles.container, styles[calculateFlexPosition(position)], styles[gap]);
  return <div className={classes}>
  {
    nonEmptyChildren
  }
  </div>;
};


export default NxRow;